import type { TourDefinition, TourStep } from './types'

export const TRAINING_SET_DETAIL_COACH_TOUR_ID = 'trainingSetDetailCoach'
export const TRAINING_SET_DETAIL_TRAINEE_TOUR_ID = 'trainingSetDetailTrainee'
export const TRAINING_SET_DETAIL_COACH_TOUR_VERSION = 1
export const TRAINING_SET_DETAIL_TRAINEE_TOUR_VERSION = 1

const OVERVIEW_AND_PROGRESS: TourStep[] = [
  {
    id: 'overview',
    target: 'tour-set-overview',
    titleKey: 'overviewTitle',
    bodyKey: 'overviewBody',
    iconId: 'sets',
  },
  {
    id: 'progress',
    target: 'tour-set-progress',
    titleKey: 'progressTitle',
    bodyKey: 'progressBody',
    iconId: 'today',
    optional: true,
  },
]

/** Coach tour: overview, progress, and each manage action. */
export const TRAINING_SET_DETAIL_COACH_TOUR: TourDefinition = {
  id: TRAINING_SET_DETAIL_COACH_TOUR_ID,
  version: TRAINING_SET_DETAIL_COACH_TOUR_VERSION,
  copyKey: 'trainingSetDetailCoach',
  hasWelcome: false,
  steps: [
    ...OVERVIEW_AND_PROGRESS,
    {
      id: 'complete',
      target: 'tour-set-action-complete',
      titleKey: 'completeTitle',
      bodyKey: 'completeBody',
      iconId: 'plan',
      optional: true,
    },
    {
      id: 'report',
      target: 'tour-set-action-report',
      titleKey: 'reportTitle',
      bodyKey: 'reportBody',
      iconId: 'more',
      optional: true,
    },
    {
      id: 'unpaid',
      target: 'tour-set-action-unpaid',
      titleKey: 'unpaidTitle',
      bodyKey: 'unpaidBody',
      iconId: 'account',
      optional: true,
    },
    {
      id: 'pause',
      target: 'tour-set-action-pause',
      titleKey: 'pauseTitle',
      bodyKey: 'pauseBody',
      iconId: 'schedule',
      optional: true,
    },
    {
      id: 'resume',
      target: 'tour-set-action-resume',
      titleKey: 'resumeTitle',
      bodyKey: 'resumeBody',
      iconId: 'schedule',
      optional: true,
    },
    {
      id: 'cancel-pause',
      target: 'tour-set-action-cancel-pause',
      titleKey: 'cancelPauseTitle',
      bodyKey: 'cancelPauseBody',
      iconId: 'schedule',
      optional: true,
    },
    {
      id: 'delete',
      target: 'tour-set-action-delete',
      titleKey: 'deleteTitle',
      bodyKey: 'deleteBody',
      iconId: 'more',
      optional: true,
    },
  ],
}

/** Trainee tour: overview + progress only (no manage actions). */
export const TRAINING_SET_DETAIL_TRAINEE_TOUR: TourDefinition = {
  id: TRAINING_SET_DETAIL_TRAINEE_TOUR_ID,
  version: TRAINING_SET_DETAIL_TRAINEE_TOUR_VERSION,
  copyKey: 'trainingSetDetailTrainee',
  hasWelcome: false,
  steps: OVERVIEW_AND_PROGRESS,
}
